<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">智能终端AI数据解决方案</div>
          <div class="t22">
            行业领先的标注平台和全面的数据服务，支持您多样化的智能终端AI数据需求
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">咨询数据解决方案</div>
        </div>
      </div>
    </div>
    <div class="w1280" style="margin: 48px auto;">
      <div class="flexs">
        <div style="width: 48%;">
          <div class="title-1">全面支持您的智能终端需求</div>
          <div class="title-2">提供全面的数据服务支持，为智能终端行业完成了数十个项目的交付，为您的海内外AI应用场景提供全流程数据服务。</div>
          <ul>
            <li>超过 7 年的行业专业知识</li>
            <li>与领先的智能终端企业合作</li>
            <li>全球采集能力支持您的目标应用场景进行大规模数据生产</li>
            <li>全数据类型标注支持</li>
            <li>大模型全流程支持</li>
          </ul>
        </div>
        <div style="width: 48%;">
          <img style="width: 100%;border-radius:16px" src="../assets/img/sjfw/b5.webp" alt="">
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">应用场景：智能终端</div>
      
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据解决方案</div>
      <div class="slogan">提供全面的数据采集、标注、测试服务，涵盖多种数据类型，支持您的智能终端AI数据需求。</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据采集定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>小学、初高中题库数据采集</li>
                  <li>语音发音数据采集</li>
                  <li>健康类数据采集（心率，血氧，血糖等）</li>
                  <li>家居环境数据采集</li>
                  <li>虚拟人及动作捕捉采集</li>
                  <li>无人机数据采集</li>
                  <li>生产线及产品数据采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              咨询定制标注服务
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/j3.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/dog.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据标注定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>公式标注</li>
                  <li>试卷OCR标注</li>
                  <li>人脸标注</li>
                  <li>语音及声纹标注</li>
                  <li>婴儿哭声标注</li>
                  <li>跨镜追踪标注</li>
                  <li>全景语义分割标注</li>
                  <li>物体识别标注</li>
                  <li>3D点云数据标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">多垂直领域的数据经验</div>
      <div class="t2">多应用场景与数据类型的数据采集标注经验支持您进行多种智能终端的AI部署</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "一站式数据管理",
          content:
            "我们已经成功交付多种类互联网AI数据项目，提供采集、数据清洗、数据标注、模型测试的一站式数据管理服务。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "全球团队",
          content:
            "在海内外拥有众多众包，同时在海外也有自有标注基地，为您的出海项目提供全面支持。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "AI辅助标注工具",
          content:
            "企业级高精度数据标注平台支持AI辅助的数据预标注及质检，大大提高数据标注效率，并保证交付质量，为您提供高质量数据服务。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "数据安全",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，同时有1000+内部标注员为您的高安全要求提供支持。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "教育教辅",
          img: require("../assets/img/sjfw/c1.webp"),
          textList: [
            {
              title: "",
              content: "教育教辅行业已经涌现诸多智能终端产品，例如点读机，翻译器，为学生和教育工作者提供了更多的学习资源和工具，促进了教育的创新和发展。其中，拍照搜题，发音评测，自动批改等AI应用，均需要专业的数据支持。",
            }
          ],
        },
        {
          title: "智能家居",
          img: require("../assets/img/sjfw/c2.webp"),
          textList: [
            {
              title: "",
              content: "智能家居已经成了新房装修的重要组成：能够进行语音对话的智能音箱，能够对全屋进行自动扫描避障的扫地机器人，全屋互通的智能中枢等新产品。随着市场需求细致化，更多的精细数据需求必不可少。",
            },
           
          ],
        },
        {
          title: "智能安防",
          img: require("../assets/img/sjfw/c3.webp"),
          textList: [
            {
              title: "",
              content:"智能安防包括智能监控与识别，人员识别，行为检测，事件判断，以及智能报警等，已配备在智能门锁、智能闸机等方面，为家庭、园区、医院等场所提供了更高级别以及更高效率的安保措施，也需要更加细分及精确的数据支持。",
            },
          ],
        },
        {
          title: "VR设备",
          img: require("../assets/img/sjfw/c4.webp"),
          textList: [
            {
              title: "",
              content:
                "VR设备，如VR眼镜，VR舱等，离不开AI的支持：虚拟效果生成及增强，内容动态调整及个性化，实时反馈及交互等，同时也包括语音识别、手势识别和智能导航等辅助功能。AI支持VR提供丰富的虚拟现实体验，提升用户参与感和沉浸感，同时提供更智能化的交互和辅助功能。",
            },
            
          ],
        },
        {
          title: "无人机",
          img: require("../assets/img/sjfw/c5.webp"),
          textList: [
            {
              title: "",
              content:
                "AI技术为无人机的自主性、智能性和效率提供了重要支持。其中，目标识别及跟踪，智能飞行控制，自主飞行，智能避障，多机协作等，拓展了无人机在各个领域的应用潜力，包括军事、民用、科研等领域。",
            },
            
          ],
        },
        {
          title: "工业机器人",
          img: require("../assets/img/sjfw/c6.webp"),
          textList: [
            {
              title: "",
              content:
                "工业机器人在制造业中扮演着重要角色，用于自动化生产线上的各种任务。物体识别及分析，品质检测，智能避障，路线规划及优化，智能任务分配和调度等AI应用支持工业机器人更加智能化、灵活化地应对复杂的生产需求，提高生产效率、质量和安全性。",
            },
            
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1{
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2{
      font-size:16px;
      line-height: 1.5;
    }
    li{
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
